const React = require('react');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const withState = require('../../../../utils/withState');
const {
  bankName$,
  loadingBankNameGet$,
} = require('../../../../emitters/cash');


module.exports = withState(() => {
  return (state, props) => {
    const {
      bankName,
    } = state;
    return (
      <WrapperWithLoading
        {...props}
        loading={state.loading}
      >
        {bankName ? (
          <div>Bank: {bankName}</div>
        ) : null}
      </WrapperWithLoading>
    );
  };
}, {
  bankName: bankName$,
  loading: loadingBankNameGet$,
});
